import React, {FC, ReactElement} from 'react';
import './ElementPlaceholder.scss';
import styled from 'styled-components';

export type ElementPlaceholderProps = {
    path: {
        slideIndex: number,
        comboIndex: number,
        setIndex: number,
        groupIndex: number,
        elementIndex: number | null,
    } | null,
    groupIndex: number,
    editorPlugins: any | null,
    isEmptySlide: boolean|null,
}

type ElementPlaceholderDesignedProps = {
    isDraggingOver:boolean|null
}


export const ElementPlaceholderDesigned = styled.div<ElementPlaceholderDesignedProps>`
     ${props => props.isDraggingOver &&`
      background: rgba(22, 118, 208, 0.05) !important;
      border: 1px solid #1676D0 !important;
      cursor: move;
      > * {
      opacity: 0;
      }
  `};
`;

const ElementPlaceholder: FC<ElementPlaceholderProps> = ({...props}): ReactElement => {

    const useAppSelector = props.editorPlugins.useAppSelector;
    const useAppDispatch = props.editorPlugins.useAppDispatch;
    const openElementsLibrary = props.editorPlugins.openElementsLibrary;
    const updateData = props.editorPlugins.updateData;
    const Droppable = props.editorPlugins.droppable;
    const selectActiveSet = props.editorPlugins.selectActiveSet;
    const dispatch = useAppDispatch();

    const globalData: any | null = useAppSelector((state: any) => state.editor.present.data);
    const activePath: any = useAppSelector((state: any) => state.editor.present.activePath);
    const currentPath = getCurrentPath();
    let imagePlaceHolder;
    try {
        imagePlaceHolder = require('../../../assets/images/imagePlaceholder.jpg').default;
    } catch (ex) {
        imagePlaceHolder = null;
    }


    const Image = {
        name: 'Image', //string
        data: { //object
            src: imagePlaceHolder, //string
            alt: 'Image', //string
            isShadow: true, //boolean
            shadowColor: '#00000025', //string
            round: '8px', //boolean
            width: '100', //string,
        }
    };
    const Video = {
        name: 'Video', //strin
        data: { //object
            src: '', //string
            type: 'Library',
            isShadow: true, //boolean
            shadowColor: '#00000025', //string
            round: '8px', //boolean
            width: '100', //string,
            code: null,
            controls: true,
            loop: true,
            autoplay: true,
        }
    };

    function getCurrentPath() {
        let path;
        if (props.path) path = {...props.path};
        if (!props.path) path = {...activePath};
        path.groupIndex = props.groupIndex;
        path.elementIndex = 0;
        return path;
    }

    function addElement(elementObj: any) {

        elementObj.data.isAddElement = true;

        let obj = {
            name: elementObj.name,
            data: elementObj.data
        };
        let elements = props.isEmptySlide ? [] : [...globalData.slides[currentPath.slideIndex].combos[currentPath.comboIndex].sets[currentPath.setIndex].groups[currentPath.groupIndex]];
        elements.splice(currentPath.elementIndex + 1, 0, obj);
        let data = {
            path: currentPath,
            data: elements,
            object: 'element',
            isEmptySlide: props.isEmptySlide
        };
        dispatch(updateData(data));
    }

    function clickOpenElementsLibrary() {
        let path = {...currentPath};
        if(props.isEmptySlide) {
            path.setIndex = null;
            path.groupIndex = null;
            path.elementIndex = null;
        }
        let data = {
            path: path,
            type: 'element',
            isEmptySlide: props.isEmptySlide
        };
        dispatch(selectActiveSet(''));
        dispatch(openElementsLibrary(data));
    }


    return (
        <Droppable droppableId={props.path?.slideIndex + '-' + props.path?.comboIndex + '-' + props.path?.setIndex + '-' + props.path?.groupIndex} type={'element'}>
            {(provided: any, snapshot: any) => (
                <ElementPlaceholderDesigned className={'addElementPlaceholder ' + (snapshot.isDraggingOver ? 'dragging' : '')}
                     ref={provided.innerRef}
                     {...provided.droppableProps}
                     isDraggingOver={snapshot.isDraggingOver}>
                    <p className="title">Add element:</p>
                    <ul className="elementsList">
                        <li className={'elementItem'} onClick={() => {
                            addElement(Image);
                        }}>
                            <div className="icon">
                                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <g clipPath="url(#clip0_830_97652)">
                                        <path
                                            d="M5 11.1L7 9.1L12.5 14.6L16 11.1L19 14.1V5H5V11.1ZM4 3H20C20.2652 3 20.5196 3.10536 20.7071 3.29289C20.8946 3.48043 21 3.73478 21 4V20C21 20.2652 20.8946 20.5196 20.7071 20.7071C20.5196 20.8946 20.2652 21 20 21H4C3.73478 21 3.48043 20.8946 3.29289 20.7071C3.10536 20.5196 3 20.2652 3 20V4C3 3.73478 3.10536 3.48043 3.29289 3.29289C3.48043 3.10536 3.73478 3 4 3ZM15.5 10C15.1022 10 14.7206 9.84196 14.4393 9.56066C14.158 9.27936 14 8.89782 14 8.5C14 8.10218 14.158 7.72064 14.4393 7.43934C14.7206 7.15804 15.1022 7 15.5 7C15.8978 7 16.2794 7.15804 16.5607 7.43934C16.842 7.72064 17 8.10218 17 8.5C17 8.89782 16.842 9.27936 16.5607 9.56066C16.2794 9.84196 15.8978 10 15.5 10Z"
                                            fill="#12033E"/>
                                    </g>
                                    <defs>
                                        <clipPath id="clip0_830_97652">
                                            <rect width="24" height="24" fill="white"/>
                                        </clipPath>
                                    </defs>
                                </svg>

                            </div>
                            <p className="title">Image</p>
                        </li>
                        <li className={'elementItem'} onClick={() => {
                            addElement(Video);
                        }}>
                            <div className="icon">
                                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <g clipPath="url(#clip0_830_97657)">
                                        <path
                                            d="M3 3.993C3 3.445 3.445 3 3.993 3H20.007C20.555 3 21 3.445 21 3.993V20.007C20.9997 20.2703 20.895 20.5227 20.7089 20.7089C20.5227 20.895 20.2703 20.9997 20.007 21H3.993C3.72972 20.9997 3.4773 20.895 3.29114 20.7089C3.10497 20.5227 3.00026 20.2703 3 20.007V3.993ZM10.622 8.415C10.5618 8.37485 10.4919 8.35177 10.4196 8.34822C10.3473 8.34467 10.2755 8.36079 10.2116 8.39486C10.1478 8.42893 10.0944 8.47967 10.0572 8.54168C10.0199 8.60369 10.0001 8.67465 10 8.747V15.253C10.0001 15.3253 10.0199 15.3963 10.0572 15.4583C10.0944 15.5203 10.1478 15.5711 10.2116 15.6051C10.2755 15.6392 10.3473 15.6553 10.4196 15.6518C10.4919 15.6482 10.5618 15.6252 10.622 15.585L15.501 12.333C15.5559 12.2965 15.6009 12.247 15.632 12.1889C15.6631 12.1308 15.6794 12.0659 15.6794 12C15.6794 11.9341 15.6631 11.8692 15.632 11.8111C15.6009 11.753 15.5559 11.7035 15.501 11.667L10.621 8.415H10.622Z"
                                            fill="#12033E"/>
                                    </g>
                                    <defs>
                                        <clipPath id="clip0_830_97657">
                                            <rect width="24" height="24" fill="white"/>
                                        </clipPath>
                                    </defs>
                                </svg>
                            </div>
                            <p className="title">Video</p>
                        </li>
                        <li className={'elementItem'} onClick={() => {
                            clickOpenElementsLibrary();
                        }}>
                            <div className="icon">
                                <svg width="12" height="4" viewBox="0 0 12 4" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path
                                        d="M1.91667 0.833496C1.275 0.833496 0.75 1.3585 0.75 2.00016C0.75 2.64183 1.275 3.16683 1.91667 3.16683C2.55833 3.16683 3.08333 2.64183 3.08333 2.00016C3.08333 1.3585 2.55833 0.833496 1.91667 0.833496ZM10.0833 0.833496C9.44167 0.833496 8.91667 1.3585 8.91667 2.00016C8.91667 2.64183 9.44167 3.16683 10.0833 3.16683C10.725 3.16683 11.25 2.64183 11.25 2.00016C11.25 1.3585 10.725 0.833496 10.0833 0.833496ZM6 0.833496C5.35833 0.833496 4.83333 1.3585 4.83333 2.00016C4.83333 2.64183 5.35833 3.16683 6 3.16683C6.64167 3.16683 7.16667 2.64183 7.16667 2.00016C7.16667 1.3585 6.64167 0.833496 6 0.833496Z"
                                        fill="#12033E"/>
                                </svg>
                            </div>
                            <p className="title">More</p>
                        </li>
                    </ul>
                    {provided.placeholder}
                </ElementPlaceholderDesigned>
            )}
        </Droppable>
    );

};

export default ElementPlaceholder;
